export const convertingStatusTable = {
  new: 'Novo',
  open: 'Aberto',
  waiting: 'Em espera',
  pending: 'Pendente',
  solved: 'Resolvido',
  closed: 'Fechado',
};

export type StatusKeys = keyof typeof convertingStatusTable;
